module.exports = __webpack_public_path__ + "static/media/jucileideEquipe.deed93fd.jpg";